import {
  RECEIVE_LOCATION_DATA,
  RECEIVE_CURRENT_CONGESTION_RATE,
  RECEIVE_CONGESTION_TREND,
} from '../actions'

const initialState = {
  locations: {},
  currentCongestions: {},
  congestionTrends: {},
}

const reducer = (state = initialState, action) => {
  const { locationId, payload } = action

  switch (action.type) {
    case RECEIVE_LOCATION_DATA:
      return {
        ...state,
        locations: {
          ...state.locations,
          [locationId]: payload,
        },
      }
    case RECEIVE_CURRENT_CONGESTION_RATE:
      return {
        ...state,
        currentCongestions: {
          ...state.currentCongestions,
          [locationId]: payload,
        },
      }
    case RECEIVE_CONGESTION_TREND:
      return {
        ...state,
        congestionTrends: {
          ...state.congestionTrends,
          [locationId]: payload,
        },
      }
    default:
      return state
  }
}

export default reducer